// Sprint 4c-3 C.1 — 2-Layer-Farbsystem.
// Role-based colors (Primary/Gegenüber/Nachbarn) liegen ÜBER den Identity-Farben
// (Eule=Braun, Biene=Grün, Katze=Gelb, Hund=Orange) in Tiles/Glyphs.

// Diagonal-Mapping aus quickTestData.js DIAGONALE_BY_FOKUSTYP (Single Source).
export const DIAGONAL_OPPOSITE = {
  eule: "hund",
  biene: "katze",
  katze: "biene",
  hund: "eule",
};

// Sprint M5.36 (29.07.2026) — Issue 13: Verbindliche 4er-Matrix-Reihenfolge.
// Oben links: Katze · oben rechts: Eule · unten rechts: Biene · unten links: Hund.
// In-Uhrzeigersinn-Lesung von OL: Katze → Eule → Biene → Hund.
export const ALL_FOKUSTYPEN = ["katze", "eule", "biene", "hund"];

// Role-Hex-Codes (Andreas final 4c-3).
export const ROLE_COLORS = {
  primary: {
    hex: "#15803D", // Forest
    bg: "#DCFCE7",
    label: "Dein Anteil",
  },
  gegenueber: {
    hex: "#DC2626", // Crimson
    bg: "#FEE2E2",
    label: "Gegenüber (diagonal)",
  },
  nachbarn: {
    hex: "#CA8A04", // Amber
    bg: "#FEF3C7",
    label: "Nachbarn",
  },
};

// Bestimmt die Rolle eines Ziel-FT relativ zum User-Primary.
export function getRole(primarySlug, targetSlug) {
  if (!primarySlug || !targetSlug) return "nachbarn";
  if (primarySlug === targetSlug) return "primary";
  if (DIAGONAL_OPPOSITE[primarySlug] === targetSlug) return "gegenueber";
  return "nachbarn";
}

// Convenience: gibt Hex + BG für einen Ziel-FT bezogen auf den Primary zurück.
export function getRoleColors(primarySlug, targetSlug) {
  const role = getRole(primarySlug, targetSlug);
  return { role, ...ROLE_COLORS[role] };
}
